import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useTable } from '@app/components/table';
import { Strings } from '@app/constants';
import { useDialog, useRequestState } from '@app/hooks';
import { Header } from '@app/sections/header';
import { IntervieweeList } from './interviewee-list';
import { AddInterviewee } from './add-interviewee-form';
import { getInterviewee, searchInterviewee } from '../slice';
import { selectIntervieweeState, selectSearchIntervieweeState } from '../selecter';
import { useAuthRole } from '@app/utils';

const IntervieweeListPage = () => {
  const tableProps = useTable();
  const intervieweeDialog = useDialog();
  const dispatch = useDispatch();

  const [query, setQuery] = useState('');

  const { data, loading } = useRequestState({
    stateSelector: query.length > 0 ? selectSearchIntervieweeState : selectIntervieweeState,
    errorShown: true,
  });
  const { isManager } = useAuthRole();

  useEffect(() => {
    if (query.length !== 0) {
      dispatch(searchInterviewee(query));
    } else {
      dispatch(getInterviewee());
    }
  }, [dispatch, query]);

  const handleSearchChange = (event: any) => {
    setQuery(event.target.value);
  };

  return (
    <>
      <Header
        title={Strings.page_title.interviewees}
        helperText={''}
        actionButtonTitle={isManager ? undefined : Strings.button.addInterviewee}
        onClickActionButton={intervieweeDialog.show}
        searchBarProps={{
          placeholder: Strings.common.idNameEmail,
          onChange: handleSearchChange,
        }}
      />

      <IntervieweeList
        tableProps={tableProps}
        rows={data}
        loading={loading}
        isManager={isManager}
      />
      {intervieweeDialog.visible && <AddInterviewee open onClose={intervieweeDialog.hide} />}
    </>
  );
};

export { IntervieweeListPage };
